import * as React from "react";
import styles from "./index.module.css";

type Props = {
  value: number;
  rating: number;
  onClick: (value: number) => void;
  disabled: boolean;
};

const Star: React.FC<Props> = ({ rating, value, onClick, disabled }) => {
  return (
    <>
      <input
        id={`rate${value}`}
        className={styles.star}
        defaultChecked={rating === value}
        type="radio"
        name="rate"
        disabled={disabled}
        onClick={() => onClick(value)}
        onKeyDown={(e) => e.preventDefault()}
      />
      <label
        htmlFor={`rate${value}`}
        onClick={(e) => {
          e.stopPropagation();
        }}
      />
    </>
  );
};

export default Star;
